<template>
    <v-combobox-filled
        v-model="result"
        hide-details
        :items="suggestedAdresses"
        :readonly="readonly"
        :label="label || 'Adresse'"
        @update:search="query = $event"
        autocomplete="off"
        :list-props="{ maxWidth: comboListMaxWidth }"
    />
</template>

<script lang="ts">
import getEnv from "../env";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch, Emit } from "vue-facing-decorator";

const env: any = getEnv();

@Component
export class HereAddress extends Vue {
    @Prop({ default: false }) readonly!: any;
    @Prop({ default: "" }) wordingAddress!: any;
    @Prop({ default: "" }) label!: any;
    @Prop({ default: "", type: String }) listMaxWidth?: String;

    AUTOCOMPLETION_URL = "https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json";
    ajaxRequest = null;
    result_ = null;
    geocoder = null;
    location = null;
    query = "";

    suggestedAdresses = [];
    coordinates = [];

    get comboListMaxWidth() {
        // Should not exceed the parent dialog's width, otherwise it will throw a Resize Observer error
        return this.listMaxWidth || (this.$vuetify.display.mobile ? "300px" : "undefined");
    }

    beforeMount() {
        if (this.readonly) {
            return;
        }
        this.ajaxRequest = new XMLHttpRequest();
        // not the best way. maybe at some point we should create a definition for window.H and refactor this.
        const H = (window as any).H;
        const platform = new H.service.Platform({
            apikey: env.HEREMAP_APIKEY,
        });
        this.geocoder = platform.getGeocodingService();
    }

    get result() {
        if (this.wordingAddress) {
            return this.wordingAddress;
        }
        return this.result_;
    }

    set result(v: any) {
        this.result_ = v;
    }

    @Emit("coordinates")
    onCoordinates(coordinates) {
        return coordinates;
    }

    @Watch("result_")
    async geocodeByLocationId() {
        if (this.readonly || !this.geocoder || !this.result_?.value) {
            console.error("geocodeByLocationId");
            return;
        }
        const sa = this.suggestedAdresses.find((sa) => sa.value === this.result_.value);
        if (!sa) {
            return;
        }
        debugger;
        const result = await this.geocoder.geocode({
            locationId: sa.value,
        });
        try {
            if (result) {
                const latitude =
                    result.Response.View[0].Result[0].Location.MapView.BottomRight.Latitude;
                const longitude =
                    result.Response.View[0].Result[0].Location.MapView.BottomRight.Longitude;
                const coordinates = { latitude, longitude, wordingAddress: sa.title };
                this.onCoordinates(coordinates);
                // return result;
            }
        } catch (error) {
            console.log(error);
        }
    }

    formatAddress(address) {
        return `${address.houseNumber || ""} ${address.street || ""}, ${
            address.district ? address.district + " " : ""
        }${address.city || ""} ${address.postalCode || ""}, ${address.country || ""}`.trim();
    }

    @Watch("query")
    async onQueryChanged() {
        console.log(this.query);
        if (this.query && this.query.length > 3 && this.ajaxRequest) {
            this.ajaxRequest.abort();
            this.ajaxRequest.open(
                "GET",
                `${this.AUTOCOMPLETION_URL}?apiKey=${env.HEREMAP_APIKEY}&query=${this.query}&maxresults=5&language=fr`,
            );
            await this.ajaxRequest.send();
            this.ajaxRequest.onreadystatechange = () => {
                // console.log(this.ajaxRequest)
                if (this.ajaxRequest.readyState === 4 && this.ajaxRequest.responseText) {
                    const response = JSON.parse(this.ajaxRequest.responseText);
                    this.suggestedAdresses = response.suggestions.map((suggestion) => {
                        return {
                            title: this.formatAddress(suggestion.address),
                            value: suggestion.locationId,
                        };
                    });
                    console.log(this.suggestedAdresses);
                }
            };
        }
    }

    @Watch("wordingAddress")
    onWordingAddressChanged() {
        if (this.wordingAddress) {
            this.query = "";
        }
    }
}

export default toNative(HereAddress);
</script>
